export const SUPPORTED_FILE_ICONS = [
    'video',
    'image',
    'music',
    'pdf',
    'txt',
    'psd',
    'microsoft_word',
    'microsoft_excel',
    'microsoft_power_point',
    'microsoft_visio',
    'microsoft_project',
    'microsoft_one_note',
    'epub',
];
export const SUPPORTED_ICONS = {
    '8': [
        'arrow_down_small',
        'arrow_up_small',
        'check',
        'close',
        'equal',
        'filter',
        'link',
        'minus',
        'not_equal',
        'plus',
    ],
    '16': [
        'access',
        'activities',
        'agenda',
        'ai',
        'align_center',
        'align_left',
        'align_right',
        'announcement',
        'arrow_curved_left',
        'arrow_curved_right',
        'arrow_double_down_thin',
        'arrow_double_left_thin',
        'arrow_double_right_thin',
        'arrow_double_up_thin',
        'arrow_down',
        'arrow_down_small',
        'arrow_down_thin',
        'arrow_go_to_end_small',
        'arrow_go_to_end_thin',
        'arrow_go_to_start_small',
        'arrow_go_to_start_thin',
        'arrow_left',
        'arrow_left_small',
        'arrow_left_thin',
        'arrow_right',
        'arrow_right_small',
        'arrow_right_thin',
        'arrow_unsort_small',
        'arrow_unsort_thin',
        'arrow_up',
        'arrow_up_small',
        'arrow_up_thin',
        'asterisk',
        'attach',
        'audio',
        'audit',
        'authentication_app',
        'award',
        'battery',
        'block',
        'bold',
        'book',
        'border_color',
        'bullet_list',
        'burger',
        'burger_left',
        'burger_right',
        'calendar',
        'calendar_date',
        'calendar_date_time',
        'card',
        'card_nested',
        'card_text',
        'category',
        'chart_area',
        'chart_average',
        'chart_bar',
        'chart_column',
        'chart_combine',
        'chart_line',
        'chart_metric',
        'chart_pie',
        'chart_radar',
        'chart_sankey',
        'chart_supply_demand',
        'chart_surplus',
        'chat',
        'check',
        'check_circle',
        'check_list',
        'checkbox',
        'checkboxes',
        'classifier',
        'clean_formatting',
        'close',
        'close_circle',
        'cloud',
        'cloud_download',
        'cloud_off',
        'collapse',
        'comment',
        'comment_text',
        'compare',
        'condition',
        'condition_add',
        'configuration',
        'copy',
        'copy_lock',
        'credit_card',
        'crop',
        'crop_landscape',
        'crop_portrait',
        'crown',
        'currency',
        'currency_amd',
        'dashboard',
        'data',
        'data_export',
        'data_import',
        'data_management',
        'data_warning',
        'day',
        'decimal',
        'decrease_indent',
        'delete',
        'desktop',
        'diagram_horizontal',
        'diagram_vertical',
        'disability',
        'dock_station',
        'document',
        'document_export',
        'document_import',
        'documents',
        'download',
        'drag',
        'edit',
        'editor',
        'entity',
        'equal',
        'excel',
        'exit',
        'exit_full_screen',
        'exp',
        'expand',
        'expand_horizontal',
        'export',
        'factory',
        'faq',
        'field',
        'field_add',
        'file',
        'file_add',
        'files',
        'filter',
        'filter_add',
        'filter_remove',
        'fit_to_screen',
        'flag',
        'flash',
        'flip',
        'folder',
        'folder_add',
        'folder_doc',
        'folders',
        'form',
        'formal',
        'format_color_fill',
        'format_size_aa',
        'format_size_tt',
        'function',
        'gavel',
        'go_full_screen',
        'grid_add',
        'guarantee',
        'hand',
        'handshake',
        'header',
        'help',
        'history',
        'home',
        'household',
        'identity',
        'image',
        'images',
        'import',
        'in_progress',
        'increase_indent',
        'indicator',
        'information',
        'integer',
        'italic',
        'justified',
        'key',
        'lamp',
        'landscape',
        'layers',
        'libra',
        'link',
        'loading',
        'lock',
        'lock_open',
        'lock_secure',
        'lock_insecure',
        'logout',
        'lookup',
        'me_disaggregation',
        'mail',
        'main_entity',
        'map_marker',
        'matrix',
        'media_stop',
        'merge',
        'metering',
        'microphone',
        'microphone_off',
        'milestone',
        'minus',
        'minus_box',
        'minus_circle',
        'mobile',
        'money',
        'money_amd',
        'monitoring',
        'month',
        'more',
        'more_vertical',
        'move',
        'move_to_folder',
        'multi_language',
        'multi_lookup',
        'my_pages',
        'name',
        'not_equal',
        'note',
        'notification',
        'notification_off',
        'number',
        'number_list',
        'ocr',
        'office',
        'open_in_new',
        'open_mail',
        'overdue',
        'page_management',
        'page_number',
        'pause',
        'pdf',
        'perm_data_setting',
        'person_heart_beat',
        'phonelink',
        'photo_camera',
        'pin',
        'play',
        'plus',
        'plus_box',
        'plus_circle',
        'policies',
        'portrait',
        'ppt',
        'profiles',
        'program',
        'project',
        'qr',
        'qr_scan',
        'radio_button',
        'receipt',
        'refresh',
        'refine',
        'replace_to_left',
        'replace_to_right',
        'reply',
        'report',
        'report_bar_text',
        'report_bar_text_pie',
        'report_pie_bar',
        'report_text_line',
        'reports',
        'reset',
        'resize_diagonal',
        'resize_diagonal_mirrored',
        'resize_horizontal',
        'resize_vertical',
        'rotate',
        'safe',
        'save',
        'school',
        'screen_share',
        'screen_share_off',
        'screen_share_close',
        'search',
        'security',
        'send',
        'settings',
        'share',
        'shopping_cart',
        'shorten',
        'sign',
        'slash',
        'slider',
        'social_development',
        'social_welfare',
        'speaker',
        'speaker_off',
        'stamp',
        'star',
        'star_half',
        'strategy',
        'strikethrough',
        'subform',
        'subprogram',
        'subway_map',
        'sum',
        'survey',
        'survey_results',
        'switch_to_online',
        'system',
        'tab',
        'table',
        'table_dip_both',
        'table_dip_left',
        'table_dip_right',
        'table_grid',
        'table_hierarchy',
        'table_list',
        'table_with_pop_up',
        'tablet',
        'tabs',
        'tag',
        'text_color',
        'time',
        'timeline_horizontal',
        'timeline_vertical',
        'tooltip',
        'total_reach',
        'transcription',
        'transcription_download',
        'tree',
        'trending_up',
        'underline',
        'unlink',
        'unpin',
        'upload',
        'usb',
        'user',
        'user_add',
        'user_arrow',
        'user_budgetholder',
        'user_checked',
        'user_group',
        'user_group_rating',
        'user_management',
        'user_pages',
        'user_parent',
        'user_tie',
        'variable',
        'video',
        'video_camera',
        'video_off',
        'view_columns',
        'view_grid',
        'view_off',
        'view_on',
        'view_speaker',
        'view_visibility',
        'voice',
        'warning',
        'warning_circle',
        'watermark',
        'week',
        'workflow',
        'workspace',
        'word',
        'world',
        'zip',
        'zoom_in',
        'zoom_out',
        'print',
        'signature',
    ],
    '24': [
        'access',
        'accounting',
        'activities',
        'agenda',
        'ai',
        'align_center',
        'align_left',
        'align_right',
        'announcement',
        'arrest',
        'arrow_curved_left',
        'arrow_curved_right',
        'arrow_double_down_thin',
        'arrow_double_left_thin',
        'arrow_double_right_thin',
        'arrow_double_up_thin',
        'arrow_down',
        'arrow_down_small',
        'arrow_down_thin',
        'arrow_go_to_end_small',
        'arrow_go_to_end_thin',
        'arrow_go_to_start_small',
        'arrow_go_to_start_thin',
        'arrow_left',
        'arrow_left_small',
        'arrow_left_thin',
        'arrow_right',
        'arrow_right_small',
        'arrow_right_thin',
        'arrow_unsort_small',
        'arrow_unsort_thin',
        'arrow_up',
        'arrow_up_small',
        'arrow_up_thin',
        'asterisk',
        'attach',
        'audio',
        'audit',
        'authentication_app',
        'award',
        'battery',
        'block',
        'bold',
        'book',
        'border_color',
        'bullet_list',
        'burger',
        'burger_left',
        'burger_right',
        'calendar',
        'calendar_date',
        'calendar_date_time',
        'card',
        'card_nested',
        'card_text',
        'category',
        'chart_area',
        'chart_average',
        'chart_bar',
        'chart_column',
        'chart_combine',
        'chart_line',
        'chart_metric',
        'chart_pie',
        'chart_radar',
        'chart_sankey',
        'chart_supply_demand',
        'chart_surplus',
        'chat',
        'check',
        'check_circle',
        'check_list',
        'checkbox',
        'checkboxes',
        'classifier',
        'clean_formatting',
        'close',
        'close_circle',
        'cloud',
        'cloud_download',
        'cloud_off',
        'collapse',
        'comment',
        'comment_text',
        'compare',
        'condition',
        'condition_add',
        'configuration',
        'copy',
        'copy_lock',
        'credit_card',
        'crop',
        'crop_landscape',
        'crop_portrait',
        'crown',
        'currency',
        'currency_amd',
        'dashboard',
        'data',
        'data_export',
        'data_import',
        'data_management',
        'data_warning',
        'day',
        'decimal',
        'decrease_indent',
        'delete',
        'desktop',
        'diagram_horizontal',
        'diagram_vertical',
        'diamond_cancel',
        'diamond_price',
        'disability',
        'disjunct',
        'dock_station',
        'document',
        'document_check',
        'document_export',
        'document_import',
        'document_person_warning',
        'document_work',
        'documents',
        'download',
        'drag',
        'edit',
        'editor',
        'end_call',
        'entity',
        'equal',
        'excel',
        'exit',
        'exit_full_screen',
        'exp',
        'expand',
        'expand_horizontal',
        'export',
        'facebook',
        'factory',
        'faq',
        'field',
        'field_add',
        'file',
        'file_add',
        'files',
        'filter',
        'filter_add',
        'filter_remove',
        'fit_to_screen',
        'flag',
        'flash',
        'flip',
        'folder',
        'folder_add',
        'folder_doc',
        'folders',
        'form',
        'formal',
        'format_color_fill',
        'format_size_aa',
        'format_size_tt',
        'function',
        'gavel',
        'gavel_check',
        'gavel_progress',
        'gavel_warnings',
        'go_full_screen',
        'grid_add',
        'guarantee',
        'hand',
        'hand_up',
        'handshake',
        'handshake_document',
        'header',
        'help',
        'history',
        'home',
        'household',
        'id',
        'identity',
        'image',
        'images',
        'import',
        'in_progress',
        'increase_indent',
        'indicator',
        'information',
        'instance_id',
        'integer',
        'italic',
        'justified',
        'key',
        'lamp',
        'landscape',
        'layers',
        'libra',
        'link',
        'linkedin',
        'loading',
        'lock',
        'lock_open',
        'lock_secure',
        'lock_insecure',
        'logout',
        'lookup',
        'me_disaggregation',
        'mail',
        'main_entity',
        'map_marker',
        'matrix',
        'merge',
        'metering',
        'microphone',
        'microphone_off',
        'milestone',
        'military_arrest',
        'military_court',
        'military_fingerprint_search',
        'military_prosecution',
        'minus',
        'minus_box',
        'minus_circle',
        'mobile',
        'money',
        'money_amd',
        'money_back',
        'money_check',
        'money_up',
        'monitoring',
        'month',
        'more',
        'more_vertical',
        'move',
        'move_to_folder',
        'multi_language',
        'multi_lookup',
        'my_pages',
        'name',
        'not_equal',
        'note',
        'notification',
        'notification_off',
        'number',
        'number_list',
        'ocr',
        'office',
        'open_in_new',
        'open_mail',
        'overdue',
        'page_management',
        'page_number',
        'parent_lookup',
        'pause',
        'pdf',
        'perm_data_setting',
        'person_heart_beat',
        'phonelink',
        'photo_camera',
        'pin',
        'play',
        'plus',
        'plus_box',
        'plus_circle',
        'policies',
        'portrait',
        'ppt',
        'price_badge',
        'price_person',
        'profiles',
        'program',
        'project',
        'prosecution',
        'qr',
        'qr_scan',
        'radio_button',
        'receipt',
        'refresh',
        'refine',
        'replace_to_left',
        'replace_to_right',
        'reply',
        'report',
        'report_bar_text',
        'report_bar_text_pie',
        'report_pie_bar',
        'report_text_line',
        'reports',
        'reset',
        'resize_diagonal',
        'resize_diagonal_mirrored',
        'resize_horizontal',
        'resize_vertical',
        'rotate',
        'safe',
        'save',
        'school',
        'screen_gavel',
        'screen_share',
        'screen_share_off',
        'screen_share_close',
        'search',
        'security',
        'send',
        'settings',
        'share',
        'shopping_cart',
        'shorten',
        'sign',
        'slash',
        'slider',
        'social_development',
        'social_welfare',
        'speaker',
        'speaker_off',
        'stamp',
        'star',
        'star_half',
        'strategy',
        'strikethrough',
        'stroke',
        'subform',
        'subprogram',
        'subway_map',
        'sum',
        'survey',
        'survey_results',
        'switch_to_online',
        'system',
        'tab',
        'table',
        'table_dip_both',
        'table_dip_left',
        'table_dip_right',
        'table_grid',
        'table_hierarchy',
        'table_list',
        'table_with_pop_up',
        'tablet',
        'tabs',
        'tag',
        'text_color',
        'time',
        'time_arrest',
        'time_warning',
        'timeline_horizontal',
        'timeline_vertical',
        'tooltip',
        'total_reach',
        'transcription',
        'transcription_download',
        'tree',
        'trending_up',
        'twitter',
        'underline',
        'unlink',
        'unpin',
        'upload',
        'usb',
        'user',
        'user_add',
        'user_arrow',
        'user_budgetholder',
        'user_checked',
        'user_group',
        'user_group_rating',
        'user_management',
        'user_pages',
        'user_parent',
        'user_tie',
        'variable',
        'video',
        'video_camera',
        'video_off',
        'view_columns',
        'view_grid',
        'view_off',
        'view_on',
        'view_speaker',
        'view_visibility',
        'voice',
        'warning',
        'warning_circle',
        'watermark',
        'week',
        'workflow',
        'workspace',
        'word',
        'world',
        'world_arrow',
        'youtube',
        'zip',
        'zoom_in',
        'zoom_out',
        'print',
        'arrest_warrant',
        'arrows_warrant',
        'box_arrow_left',
        'box_checklist',
        'box_search',
        'box',
        'cadastre',
        'calendar_person',
        'cancel_release',
        'combine',
        'combine_split',
        'company_money',
        'court',
        'court_arrow_up',
        'document_checklist',
        'document_gavel',
        'document_justice',
        'document_person',
        'document_signed',
        'fee',
        'fingerprint_arrow_left',
        'fingerprint_search',
        'folder_check',
        'forbidden',
        'globe_warrant',
        'handing_document',
        'handing_money_checklist',
        'handing_money',
        'house_forbidden',
        'house_info',
        'house_lock',
        'house_person',
        'house_value',
        'interview_visit',
        'investigation',
        'justice_document',
        'laboratory',
        'list_time',
        'media_stop',
        'medical',
        'person_close',
        'person_diagram',
        'person_document_check',
        'person_speech_podium',
        'person_speech',
        'person_warning',
        'personal_belonging_arrow_left',
        'personal_belonging',
        'release',
        'search_warrant',
        'time_arrow_right',
        'two_persons_time',
        'two_persons',
        'warrant_arrow_up',
        'case_badge',
        'case_court',
        'case_gavel',
        'case_libra',
        'case_search',
        'case_work',
        'document_edit',
        'jail',
        'jail_close',
        'jail_money',
        'jail_reset',
        'task',
        'signature',
    ],
};
